package com.macrofocus.trenddisplay.timeseriesplot

import org.mkui.color.MkColor

class TimeSeriesPlotConfiguration(
    renderer: TimeSeriesPlotRenderer,
    color: MkColor,
    lineType: LineType,
    markerType: MarkerType,
    displayValue: Boolean
) {
    enum class LineType {
        Straight, Step, None
    }

    enum class MarkerType {
        None, Point, VerticalLine
    }

    private var renderer: TimeSeriesPlotRenderer
    private var lineColor: MkColor
    private var markerColor: MkColor
    private var lineType: LineType
    private var markerType: MarkerType
    private var lineWidth: Float
    private var displayValue: Boolean
    private var markerSize: Float

    private val listeners: MutableList<TimeSeriesPlotConfigurationListener>

    init {
        this.renderer = renderer
        this.lineColor = color
        this.lineType = lineType
        this.lineWidth = 0.5f
        this.markerColor = color
        this.markerType = markerType
        this.displayValue = displayValue
        this.markerSize = 1.0f

        listeners = ArrayList<TimeSeriesPlotConfigurationListener>()
    }

    fun getRenderer(): com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotRenderer {
        return renderer
    }

    fun setRenderer(renderer: com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotRenderer) {
        if (this.renderer !== renderer) {
            this.renderer = renderer
            notifiyConfigurationChanged()
        }
    }

    fun getLineColor(): MkColor {
        return lineColor
    }

    fun setLineColor(lineColor: MkColor) {
        if (this.lineColor !== lineColor) {
            this.lineColor = lineColor
            notifiyConfigurationChanged()
        }
    }

    fun getLineType(): LineType {
        return lineType
    }

    fun setLineType(lineType: LineType) {
        if (this.lineType != lineType) {
            this.lineType = lineType
            notifiyConfigurationChanged()
        }
    }


    fun getMarkerColor(): MkColor {
        return markerColor
    }

    fun setMarkerColor(markerColor: MkColor) {
        if (this.markerColor !== markerColor) {
            this.markerColor = markerColor
            notifiyConfigurationChanged()
        }
    }

    fun getMarkerType(): MarkerType {
        return markerType
    }

    fun setMarkerType(markerType: MarkerType) {
        if (this.markerType != markerType) {
            this.markerType = markerType
            notifiyConfigurationChanged()
        }
    }

    fun getLineWidth(): Float {
        return lineWidth
    }

    fun setLineWidth(lineWidth: Float) {
        if (!this.lineWidth.equals(lineWidth)) {
            this.lineWidth = lineWidth
            notifiyConfigurationChanged()
        }
    }

    fun getDisplayValue(): Boolean {
        return displayValue
    }

    fun setDisplayValue(displayValue: Boolean) {
        if (this.displayValue !== displayValue) {
            this.displayValue = displayValue
            notifiyConfigurationChanged()
        }
    }

    fun getMarkerSize(): Float {
        return markerSize
    }

    fun setMarkerSize(markerSize: Float) {
        if (this.markerSize !== markerSize) {
            this.markerSize = markerSize
            notifiyConfigurationChanged()
        }
    }

    fun addConfigurationListener(listener: TimeSeriesPlotConfigurationListener) {
        listeners.add(listener)
    }

    fun removeConfigurationListener(listener: TimeSeriesPlotConfigurationListener) {
        listeners.remove(listener)
    }

    private fun notifiyConfigurationChanged() {
        for (listener in listeners) {
            listener.configurationChanged()
        }
    }
}
